import api from './api/api'

export const saveEdital = async (cadastroEditalDTO) => {
  return api().post('/edital/save', cadastroEditalDTO)
}

export const getEdital = async () => {
  return api().get('/publico/edital')
}

export const downloadEditalById = async (id) => {
  return api().get('/publico/edital/baixar', {params: {idEdital: id}}, {responseType: 'blob'})
}

export const getAtivo = async () => {
  return api().get('/edital/getAtivo')
}

export const getTipoByUser = async () => {
  return api().get('/edital/tipo')
}

export const getEditalById = async (id) => {
  return api().get(`/publico/edital/byId/${id}`)
}

export const getEditalRecente = async () => {
  return api().get('/edital/getEditalRecente')
}

export const getEncerrarEdital = async () => {
  return api().get('/edital/encerrarEdital')
}

export const getEditalByPerfil = async (FiltroEdital) => {
  return api().post('/edital/listagem', FiltroEdital)
}

export const reabrirEdital = async (edital) => {
  return api().post('/edital/reabrirEdital', edital)
}
